export const PRODUCT_IMG =
  'https://cdn.magicpatterns.com/uploads/jJ2ck5CF5bJ9Lj2RzftZGB/Diseno-sin-titulo-5-3.webp'

export const CHECKOUT_URL = 'https://pe-teacher-pro.impultienda.ar/checkout'

export const PRODUCT_NAME = 'PE TEACHER PRO™'

export const PRICE = '27'

export const REGULAR_PRICE = '97'

export const PILLARS = 'Lessons • Activities • Skills • Fitness • Management • Assessment'
